import { render, staticRenderFns } from "./UpdateRate.vue?vue&type=template&id=77017c36"
import script from "./UpdateRate.vue?vue&type=script&lang=js"
export * from "./UpdateRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports